/**
 * This is mostly a global spot where all of the relationship managers can get and set
 * path information from/to.
 * @module Excel/Paths
 */
export const Paths: {
  [path: string]: string;
} = {};
